import { Grid } from '@mui/material';
import React from 'react';
import { WsTypography } from 'wisestep-base';

import { ChipStyle } from '../../../../features/candidateLayout/components/childComponets/expandableText/ExpandableChips';

interface TemplateSectionProps {
  title: string;
  templates: string[];
}

const TemplateInfo: React.FC<TemplateSectionProps> = ({ title, templates }) => {
  if (templates.length === 0) return null;
  return (
    <Grid item xs={12} display="flex" justifyContent="flex-start">
      <Grid xs={3}>
        <WsTypography>{title}</WsTypography>
      </Grid>
      <Grid xs={9} container gap={1} flexWrap="wrap">
        {templates.map((template, index) => (
          <ChipStyle key={index} label={template} />
        ))}
      </Grid>
    </Grid>
  );
};

export default TemplateInfo;
